<template>
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-8 col-xl-7 col-xxl-7 col-xxxl-7 maxWidthContainer">
      <div class="card border-0 rounded-0 bg-white authentication-card radius-7">
        <div class="card-body letter-spacing col-12">
          <div class="d-flex align-items-center flex-column">
            <img class="me-2" src="../../assets/images/LOGO_NEWTEC_CLOUD_ICONE_2.png" width="80" alt="Layer">
            <h4 class="text-black fw-bold mb-0 text-center mt-3">
              Crie sua conta
            </h4>
          </div>
          <form ref="formRegister" @submit.prevent="submitRegister">
            <div class="row d-flex">
              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">Nome</label>
                <input
                  ref="name"
                  type="text"
                  name="name"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="Digite seu nome"
                  @keyup="changeInformationInputs('name')"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">
                  Celular
                </label>
                <input
                  ref="cellphone"
                  type="text"
                  name="cellphone"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="Digite o seu celular"
                  @keyup="changeInformationInputs('cellphone')"
                  @input="applyMaskPhone"
                  maxlength="15"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">
                  Telefone comercial
                </label>
                <input
                  ref="commercial_phone"
                  type="text"
                  name="commercial_phone"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="Digite o seu telefone comercial"
                  @keyup="changeInformationInputs('commercial_phone')"
                  @input="applyMaskPhone"
                  maxlength="15"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">
                  Cpf ou cnpj
                </label>
                <input
                  ref="cpf_cnpj"
                  type="text"
                  name="cpf_cnpj"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="Digite o seu cpf ou cnpj"
                  @keyup="changeInformationInputs('cpf_cnpj')"
                  @input="applyMaskCpfCnpj"
                  maxlength="18"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12">
                <label class="d-block text-black fw-semibold mb-10">
                  Email
                </label>
                <input
                  ref="email"
                  type="email"
                  name="email"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="Digite o seu email"
                  @keyup="changeInformationInputs('email')"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">
                  Senha
                </label>
                <input
                  ref="password"
                  type="password"
                  name="password"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="**************"
                  @keyup="changeInformationInputs('password')"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">
                  Confirme sua Senha
                </label>
                <input
                  ref="confirm_password"
                  type="password"
                  name="confirm_password"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="**************"
                  @keyup="changeInformationInputs('confirm_password')"
                />
              </div>

              <div class="form-group col-12">
                <div ref="error_password_message" class="error-password-message">
                  As senhas são diferentes !
                </div>
              </div>
              
              <div class="form-group col-12">
                <div ref="error_password_message_caracters" class="error-password-message-caracters">
                  A senha precisa ter pelo menos 1 número e 1 caracter especial !
                </div>
              </div>

              <div
                class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1 mb-15 mb-md-20 col-12"
              >
                <label class="form-check-label" for="remember-me">
                  Cadastrar-se implica concordar com os
                  <a href="/terms" target="_blank" class="text-decoration-none">nossos termos</a>
                </label>
              </div>

              <div class="form-group col-12">
                <button
                  class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
                  type="submit"
                  ref="button_submit_register"
                >
                  Criar conta
                </button>
              </div>

              <div class="form-group col-12">
                <div class="message-error-register" v-if="getErrorRegister != ''">
                  {{ getErrorRegister }}
                </div>
              </div>

              <span
                class="d-block text-muted text-center mt-10 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16"
              >
                Já possui uma conta?
              </span>

              <div class="form-group col-12">
                <router-link
                  to="/login"
                  class="default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
                >
                  Entrar agora
                </router-link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "RegisterContent",
  computed:{
    ...mapGetters([
      'getErrorRegister'
    ])
  },
  methods: {
    ...mapActions([
        "sendRegisterPage"
    ]),
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskCpfCnpj(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 11) {
        value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      } else {
        value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }

      input.value = value;
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    hasLetters(str) {
      return /[a-zA-Z]/.test(str);
    },
    validateCaractersInputs(data){
      data.cellphone = data.cellphone.replace(/[!@#$(.) /-]/g, "");
      data.commercial_phone = data.commercial_phone.replace(/[!@#$(.) /-]/g, "");
      data.cpf_cnpj = data.cpf_cnpj.replace(/[!@#$(.) /-]/g, "");

      return data;
    },
    checkPassword(password){
      return /[0-9]/.test(password) && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/.test(password);
    },
    submitRegister(){
      const formData = new FormData(this.$refs['formRegister']);
      var data = {};
      for (let [key, val] of formData.entries()) {
        Object.assign(data, { [key]: val })
      }

      data = this.validateCaractersInputs(data);

      let error = false;
      if(data.name == ""){
        this.$refs["name"].style.borderColor = "red";
        error = true;
      }

      if(data.cellphone == "" || this.hasLetters(data.cellphone) || data.cellphone.length < 10){
        this.$refs["cellphone"].style.borderColor = "red";
        error = true;
      }
      
      if(data.commercial_phone == "" || this.hasLetters(data.commercial_phone) || data.commercial_phone.length < 10){
        this.$refs["commercial_phone"].style.borderColor = "red";
        error = true;
      }
      
      if(data.cpf_cnpj == "" || this.hasLetters(data.cpf_cnpj) || (data.cpf_cnpj.length != 11 && data.cpf_cnpj.length != 14)){
        this.$refs["cpf_cnpj"].style.borderColor = "red";
        error = true;
      }
      
      if(data.email == ""){
        this.$refs["email"].style.borderColor = "red";
        error = true;
      }
      
      if(data.password == ""){
        this.$refs["password"].style.borderColor = "red";
        error = true;
      }
      
      if(data.confirm_password == ""){
        this.$refs["confirm_password"].style.borderColor = "red";
        error = true;
      }

      if(data.password != data.confirm_password){
        this.$refs["password"].style.borderColor = "red";
        this.$refs["confirm_password"].style.borderColor = "red";
        this.$refs["error_password_message"].style.display = "flex";
        error = true;
      } else {
        this.$refs["error_password_message"].style.display = "none";
      }

      if(!this.checkPassword(data.password)){
        this.$refs["error_password_message_caracters"].style.display = "flex";
        error = true;
      } else {
        this.$refs["error_password_message_caracters"].style.display = "none";
      }

      if(error){
        return;
      }

      this.$refs.button_submit_register.innerHTML = "Carregando...";
      this.$refs.button_submit_register.disabled = true;

      this.sendRegisterPage(data).then(() => {
        this.$refs.button_submit_register.innerHTML = "Criar conta";
        this.$refs.button_submit_register.disabled = false;
      });
    }
  }
};
</script>